function ContributionRateChangePreview() {
  this.init = function () {
    new UpdateContactInfo(session.customer, () => location.reload()).init()

    const contributionRateApplication = JSON.parse(sessionStorage.getItem('contributionRateApplication'))
    console.log('session', session)

    return {
      customer: session.customer,
      ...contributionRateApplication
    }
  }

  this.done = function () {
    $('#contribution-rate-change-preview').on('submit', submit)
    $('#consent').on('click', toggleSubmitButton)
    $('#i-am-aware').on('click', toggleSubmitButton)
  }

  function toggleSubmitButton() {
    if ($('#consent').is(':checked') && $('#i-am-aware').is(':checked')) {
      $('#submit').removeAttr('disabled')
    }
    else {
      $('#submit').attr('disabled', 'disabled')
    }
  }

  function submit(event) {
    event.preventDefault()
    const form = event.target
    const contributionRate = form['contribution-rate'].value
    console.log('will send contributionRate', contributionRate)

    new Signer(session.authType, () => prepare({contributionRate}), onSigned).sign()
  }

  function prepare(applicationData) {
    return $.post('/application/contribution-rate/prepare', applicationData)
      .then(function (response) {
        console.log('response', response)
        return response;
      })
  }

  function onSigned(signedDocument) {
    sendApplication(signedDocument).then(() => {
      location.href = '#success' +
        '?signedDocumentId=' + signedDocument['signedDocumentId'] +
        '&applicationId=' + signedDocument['applicationId'];
    })
  }

  function sendApplication(signedDocument) {
    return $.post('/application/contribution-rate/send-application', signedDocument).fail(function (xhr) {
      Logger.error('Application  : ' + xhr.responseText);
    })
  }
}